import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  primary: {
    width: '100%',
    height: '3.5rem',
    alignItems: 'center',
    textTransform: 'none',
  },
});
